export const urlObjectToUriString = (urlObject: { pathname: string; query?: Record<string, any> }) => {
  const { pathname, query = {} } = urlObject;
  const checkIfQueryExists = query && Object.entries(query).length;
  const convertedPath = checkIfQueryExists
    ? Object.entries(query).reduce((path, [key, value]) => path?.replace(`[${key}]`, value.toString()), pathname)
    : '';

  const queryString = checkIfQueryExists
    ? Object.entries(query)
        .filter(([key]) => !pathname?.includes(`[${key}]`))
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&')
    : '';

  return queryString ? `${convertedPath}?${queryString}` : convertedPath;
};
